// extracted by mini-css-extract-plugin
export var fadeOut = "videoReviews-module--fadeOut--9686a";
export var mySwiper = "videoReviews-module--mySwiper--0068d";
export var opacity100 = "videoReviews-module--opacity-100--68d11";
export var swiperButtonDisabled = "videoReviews-module--swiper-button-disabled--19a6b";
export var swiperButtonNext = "videoReviews-module--swiper-button-next--3e10a";
export var swiperButtonPrev = "videoReviews-module--swiper-button-prev--22147";
export var videoReviews = "videoReviews-module--video-reviews--adb86";
export var videoReviews__img = "videoReviews-module--video-reviews__img--2a117";
export var videoReviews__info = "videoReviews-module--video-reviews__info--f9927";
export var videoReviews__play = "videoReviews-module--video-reviews__play--3d05b";
export var videoReviews__videoBlock = "videoReviews-module--video-reviews__video-block--ee9bd";
export var videoReviews__videoFrame = "videoReviews-module--video-reviews__video-frame--d9a3d";
export var videoReviews__videoWrapper = "videoReviews-module--video-reviews__video-wrapper--7a13b";
export var videoReviews__wrapper = "videoReviews-module--video-reviews__wrapper--66214";